import type { ReactNode } from 'react';

export const symbol_arrow_insert: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M306-658v348q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-420q0-12.75 8.63-21.38Q263.25-760 276-760h420q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H348l391 391q9 9 9 21t-9 21q-9 9-21 9t-21-9L306-658Z"
		/>
	</svg>
);
